import { motion } from 'framer-motion';

const MissionContent = () => {
  const content = [
    {
      icon: 'ri-trophy-line',
      title: '高いベネフィットの提供',
      description: '我々は、お客様から頂く報酬より、高いベネフィットをお客様に提供します。',
      gradient: 'from-red to-orange-500',
    },
    {
      icon: 'ri-building-line',
      title: '永続する組織',
      description: '我々は、永続する組織を構築します。',
      gradient: 'from-blue-500 to-cyan-500',
    },
    {
      icon: 'ri-lightbulb-line',
      title: '学習と進化',
      description: '我々は、常に学習し、進化する組織であり続けます。',
      gradient: 'from-purple-500 to-pink-500',
    },
    {
      icon: 'ri-shield-check-line',
      title: '法令遵守',
      description: '我々は、法令を遵守します。（法の支配）',
      gradient: 'from-green-500 to-emerald-500',
    },
    {
      icon: 'ri-heart-line',
      title: '社会貢献',
      description: '我々は、社会に貢献します。',
      gradient: 'from-amber-500 to-yellow-500',
    },
  ];

  return (
    <section className="bg-white py-24">
      <div className="max-w-[1200px] mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="inline-block mb-4 px-5 py-2 border border-red/20 bg-red/5 rounded-full">
            <span className="text-red text-[13px] font-medium">OUR PRINCIPLES</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            経営理念
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            勝つ経営を実現するための5つの理念
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {content.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${item.gradient} rounded-2xl flex items-center justify-center mb-6`}>
                <i className={`${item.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {item.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-[15px]">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionContent;